import bemFactory from 'react-bem-factory';

export const fieldMinHeight = '28px';
export const linesNamePrefix = 'lines';

export const qa = bemFactory.qa('reqf-qbooks-acc-line-item-section');
